import React from 'react'
import {
  FormControl, InputLabel, MenuItem, Select, SelectChangeEvent,
} from '@mui/material'
import { withStyles } from 'tss-react/mui'
import { intervalInput, Period } from '@app/lib/MyEnergy/intervalValues'
import styles from './SelectString.style'

interface Props {
  classes: Record<string, string>,
  choosePeriod: (period: Period) => void,
  periodSelector: Period,
  values: string[],
}

class SelectString extends React.PureComponent<Props> {
  handleChange = (event: SelectChangeEvent) => {
    const {
      choosePeriod,
    } = this.props
    choosePeriod(event.target.value as Period)
  }

  createItems = (values: string[]) => values.map((el) => (
    <MenuItem key={el} value={el}>
      {`${I18n.t(`drop_down_menu.${el}`)}`}
    </MenuItem>
  ))

  render() {
    const {
      values,
      classes,
      periodSelector,
    } = this.props
    return (
      <FormControl variant="standard" className={classes.formControl}>
        <InputLabel htmlFor="period">{I18n.t('my_energy.period')}</InputLabel>
        <Select
          variant="standard"
          value={periodSelector}
          inputProps={{
            name: intervalInput,
            id: intervalInput,
          }}
          onChange={this.handleChange}
        >
          {this.createItems(values)}
        </Select>
      </FormControl>
    )
  }
}

export default withStyles(SelectString, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
